import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import TanStackJobTable from './TanStackJobTable';
import {
  RESULTS_PER_PAGE,
  SEARCH_DELAY
} from '../../../Constants/StringConstants';
import { sideBarContents } from './SidebarConfig';
import { SearchOutlined, SettingOutlined, DownloadOutlined } from '@ant-design/icons';
import { useDebounce } from '../../../Utils/Debounce';
import { useCallback } from 'react';
import {
  SearchJobListStyle,
  SubJobListTabContainer,
  StyledJobListSubTab,
  StyledJobListSubTabRow,
  StyledSubContainer,
  StyledTableControlContainer,
  StyledTableControlSubContainer,
  StyledJobListTableContainer,
  SettingsButton
} from './styledComponents';
import { notification } from 'antd';
import { releaseSection } from '../../../Apis/Jobs';
import ColumnSettingsModal from './ColumnSettingsModal';
import { Button } from 'antd';
import { getColumnPreferences, saveColumnPreferences } from '../../../Apis/Clinic';

const JobListTable = ({
  setselectedTab,
  currentPage,
  total,
  filterKey,
  sortOrder,
  setSortOrder,
  setCurrentPage,
  pageNoChangeHandler,
  setFilterKey,
  setSearchKey,
  availableJobs,
  activeKey,
  activeTab1,
  assignToSelf,
  assignButtonLoading,
  startAssignedJob,
  startAssignedJobWithNewEditor,
  resumeJob,
  resumeJobWithNewEditor,
  viewJob,
  releaseJobHandler,
  tableLoading,
  activeTab,
  setActivetab,
  setActiveIncompletetab,
  fetchJobList,
  setUserType,
  userType,
  setJobStatus,
  jobStatus,
  setSelfAssignedTranscriptorBadge,
  setSelfAssignedReviewerBadge,
  searchVal,
  setSearchVal,
  type,
  disableUser,
  filterConfig
}) => {
  const [theme] = useSelector(state => [state.themeReducer]);
  const [tableTitle, setTableTitle] = useState();
  const user = useSelector(state => state.userReducer);
  const [selectedId, setSelectedId] = useState();
  const [tempStatus, setTempStatus] = useState(jobStatus);
  const [selectedJobIds, setSelectedJobIds] = useState([]);
  const [releasetModalVisible, setReleaseModalVisible] = useState(false);
  const [releaseJobIds, setReleaseJobIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [releaseLoading, setReleaseLoading] = useState(false);
  const [releaseModalLoading, setReleaseModalLoading] = useState(false);

  // Column customization states
  const [visibleColumns, setVisibleColumns] = useState({
    // Default visible columns
    jobId: true,
    author: true,
    patientName: true,
    jobNumber: true,
    workType: true,
    dictationTemplate: true,
    biller: false,
    submissionTime: false,
    effectiveDate: false,
    facilityName: false,
    currentLevel: false,
    assignedTo: false,
    billStatus: false,
    reasonForFailing: false,
    submissionToReviewerLevel1Time: false,
    emrSubmissionTime: false,
    scribe: false,
    admissionDate: false,
    mrn: false,
    dischargeDate: false,
    primaryCarePhysician: false,
    actions: true
  });

  const [columnWidths, setColumnWidths] = useState({
    jobId: 150,
    author: 200,
    patientName: 210,
    jobNumber: 150,
    workType: 180,
    dictationTemplate: 240,
    biller: 150,
    submissionTime: 200,
    effectiveDate: 210,
    facilityName: 170
  });

  const [columnSettingsVisible, setColumnSettingsVisible] = useState(false);
  const [clearFiltersTrigger, setClearFiltersTrigger] = useState(0);
  const [exportFunction, setExportFunction] = useState(null);

  useEffect(() => {
    setTableTitle(sideBarContents('transcriptionist'));
    // eslint-disable-next-line
  }, []);

  // Fetch column preferences from API (reusable function)
  const fetchColumnPreferences = useCallback(async () => {
    try {
      const response = await getColumnPreferences('JOB_LIST');

      if (response.data && response.data.result && Array.isArray(response.data.result) && response.data.result.length > 0) {
        // Create default columns object
        const defaultColumns = {
          jobId: true,
          author: true,
          patientName: true,
          jobNumber: true,
          workType: true,
          dictationTemplate: true,
          biller: false,
          submissionTime: false,
          effectiveDate: false,
          facilityName: false,
          currentLevel: false,
          assignedTo: false,
          billStatus: false,
          reasonForFailing: false,
          submissionToReviewerLevel1Time: false,
          emrSubmissionTime: false,
          scribe: false,
          admissionDate: false,
          mrn: false,
          dischargeDate: false,
          primaryCarePhysician: false,
          actions: true
        };

        // Map API response to visibleColumns state
        const columnPreferences = response.data.result.reduce((acc, item) => {
          if (item.columnName && item.columnName in defaultColumns) {
            acc[item.columnName] = item.selected;
          }
          return acc;
        }, {});

        // Merge with defaults and ensure jobId is always true
        const updatedColumns = {
          ...defaultColumns,
          ...columnPreferences,
          jobId: true, // Always show Job ID
          actions: true // Always show actions column
        };

        setVisibleColumns(updatedColumns);
      }
      // If no data, fall back to default columns (already set in initial state)
    } catch (error) {
      // On error, fall back to default columns (already set in initial state)
      console.error('Failed to fetch column preferences:', error);
    }
  }, []);

  // Fetch column preferences on mount
  useEffect(() => {
    fetchColumnPreferences();
  }, [fetchColumnPreferences]);

  // Fetch column preferences when tab changes
  useEffect(() => {
    fetchColumnPreferences();
  }, [activeKey, fetchColumnPreferences]);
  // const releaseIncompleteJobs = jobId => {
  //   setReleaseJobIds(jobId);

  //   setReleaseModalLoading(true);

  //   setReleaseLoading(true);

  //   // fetchJobList(0);

  //   setReleaseModalVisible(true);

  //   setReleaseModalLoading(false);
  // };

  const handleReleaseConfirm = jobIds => {
    setReleaseModalLoading(true);

    releaseSection(jobIds, user.sessionId)
      .then(response => {
        if (response.data.success) {
          // fetchSidebarList();

          // fetchJobList(0);

          notification['success']({
            message: 'Success',

            description: response.data.message
          });

          setReleaseModalVisible(false);

          fetchJobList(0);
        } else {
          notification['error']({
            message: 'Failed',

            description: response.data.message
          });
        }

        setReleaseModalLoading(false);

        setReleaseLoading(false);
      })

      .catch(err => {
        setReleaseLoading(false);
      });
  };
  const onChangeHandler = value => {
    setSearchKey(value);
    setCurrentPage(0);
  };

  const debounceOnChange = useCallback(
    useDebounce(onChangeHandler, SEARCH_DELAY),
    []
  );

  const filterTableChange = (pagination, filters, sorter, event, event2) => {
    let sortByKey;
    let sortByOrder;
    if (sorter.length > 1) {
      sortByKey =
        sorter &&
        sorter.map(item => {
          return item.columnKey;
        });
      sortByOrder =
        sorter &&
        sorter.map(item => {
          return item.order;
        });

      setFilterKey(sortByKey);
      setSortOrder(sortByOrder);
    } else {
      sortByKey = sorter.columnKey;
      sortByOrder = sorter.order;
      if (sorter.columnKey !== undefined) setFilterKey(sortByKey);
      if (sorter.order !== undefined) setSortOrder(sortByOrder);
    }
  };

  // Column customization handlers
  const handleResize =
    columnKey =>
    (e, { size }) => {
      setColumnWidths(prev => ({
        ...prev,
        [columnKey]: size.width
      }));
    };

  const handleSaveColumnSettings = newVisibleColumns => {
    // Update local state immediately (optimistic update)
    setVisibleColumns(newVisibleColumns);

    // Convert visibleColumns object to API format
    const columnPreferencesArray = Object.keys(newVisibleColumns).map(columnName => ({
      columnName,
      selected: newVisibleColumns[columnName]
    }));

    // Make POST API call in background
    saveColumnPreferences('JOB_LIST', columnPreferencesArray)
      .then(() => {
        // On success: show notification and refetch preferences
        notification.success({
          message: 'Success',
          description: 'Column preferences saved successfully'
        });
        // Refetch column preferences to ensure sync
        fetchColumnPreferences();
      })
      .catch(error => {
        // On failure: show error notification but keep local changes
        console.error('Failed to save column preferences:', error);
        notification.error({
          message: 'Error',
          description: 'Failed to save column preferences. Please try again.'
        });
      });
  };

  const assignJobHandler = id => {
    assignToSelf(id);
    setSelectedId(id);
    activeTab === 'transcriptionist' && setSelfAssignedTranscriptorBadge(true);
    activeTab === 'reviewer' && setSelfAssignedReviewerBadge(true);
  };

  const handleChangeTab = activeKey => {
    setActivetab(activeKey);
    setUserType(activeKey);
    setCurrentPage(0);
    fetchJobList(0, '', activeKey);
    activeKey === 'transcriptionist' && setSelfAssignedTranscriptorBadge(false);
    activeKey === 'reviewer' && setSelfAssignedReviewerBadge(false);
  };

  const handleChangeIncompleteTab = activeKey => {
    setselectedTab(activeKey);
    setActiveIncompletetab(activeKey);
    fetchJobList(0, activeKey);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedJobIds(selectedRowKeys);
    },
    getCheckboxProps: record => ({
      name: record.id
    })
  };
  return (
    <>
      <StyledSubContainer>
        <StyledJobListTableContainer>
          <StyledTableControlContainer>
            <StyledTableControlSubContainer>
              <StyledJobListSubTabRow>
                <SubJobListTabContainer>
                  <StyledJobListSubTab
                    tabswidth={'500px'}
                    defaultActiveKey='ready'
                    activeKey={activeTab}
                    onChange={handleChangeTab}
                  ></StyledJobListSubTab>
                </SubJobListTabContainer>
              </StyledJobListSubTabRow>
            </StyledTableControlSubContainer>
            <StyledTableControlSubContainer>
              <SearchJobListStyle
                prefix={<SearchOutlined />}
                placeholder='Search Jobs'
                onChange={event => {
                  setSearchVal(event.target.value);
                  debounceOnChange(event.target.value);
                }}
                value={searchVal}
              />
              <SettingsButton
                icon={<DownloadOutlined />}
                onClick={() => exportFunction && exportFunction()}
              >
                Export to Excel
              </SettingsButton>
              <SettingsButton
                icon={<SettingOutlined />}
                onClick={() => setColumnSettingsVisible(true)}
              >
                Columns
              </SettingsButton>
              <SettingsButton
                onClick={() => {
                  setSearchVal('');
                  setClearFiltersTrigger(t => t + 1);
                }}
              >
                Clear Filter
              </SettingsButton>
              {/* <FacilityFilter setSelectedValues={setFacilities} /> */}
            </StyledTableControlSubContainer>
          </StyledTableControlContainer>

          <TanStackJobTable
            availableJobs={availableJobs}
            tableLoading={tableLoading}
            searchValue={searchVal}
            filterConfig={filterConfig}
            filterKey={filterKey}
            sortOrder={sortOrder}
            setFilterKey={setFilterKey}
            setSortOrder={setSortOrder}
            activeKey={activeKey}
            activeTab1={activeTab1}
            type={type}
            visibleColumns={visibleColumns}
            setVisibleColumns={setVisibleColumns}
            columnWidths={columnWidths}
            setColumnWidths={setColumnWidths}
            onExportReady={(exportFn) => setExportFunction(() => exportFn)}
            clearFiltersTrigger={clearFiltersTrigger}
            startAssignedJobWithNewEditor={startAssignedJobWithNewEditor}
            resumeJobWithNewEditor={resumeJobWithNewEditor}
            viewJob={viewJob}
            releaseJobHandler={releaseJobHandler}
            disableUser={disableUser}
            selectedId={selectedId}
            assignButtonLoading={assignButtonLoading}
            user={user}
            jobStatus={jobStatus}
            setJobStatus={setJobStatus}
            tempStatus={tempStatus}
            setTempStatus={setTempStatus}
          />
        </StyledJobListTableContainer>
      </StyledSubContainer>

      <ColumnSettingsModal
        visible={columnSettingsVisible}
        onCancel={() => setColumnSettingsVisible(false)}
        onSave={handleSaveColumnSettings}
        visibleColumns={visibleColumns}
        activeKey={activeKey}
        activeTab1={activeTab1}
      />
    </>
  );
};

export default JobListTable;
